"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderIcon = exports.EnvironmentNavigation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const NavIcons = __importStar(require("@icr-ui/icons"));
var EnvironmentNavigation;
(function (EnvironmentNavigation) {
    EnvironmentNavigation["AGP"] = "AGP";
    EnvironmentNavigation["PKC"] = "PKC";
    EnvironmentNavigation["INVOICES"] = "INVOICES";
    EnvironmentNavigation["OBJECTS"] = "OBJECTS";
    EnvironmentNavigation["MAIL_SERVER_SETTINGS"] = "MAIL_SERVER_SETTINGS";
    EnvironmentNavigation["LANGUAGE_CHANGE"] = "LANGUAGE_CHANGE";
    EnvironmentNavigation["MUTATIONS"] = "MUTATIONS";
    EnvironmentNavigation["CONNECTIONS"] = "CONNECTIONS";
    EnvironmentNavigation["COMPANYS"] = "COMPANYS";
    EnvironmentNavigation["WEBSERVICES"] = "WEBSERVICES";
    EnvironmentNavigation["USERS"] = "USERS";
    EnvironmentNavigation["HELP"] = "HELP";
    EnvironmentNavigation["FILE_TRANSFER"] = "FILE_TRANSFER";
    EnvironmentNavigation["COCKPIT"] = "COCKPIT";
    EnvironmentNavigation["ACCOUNT"] = "ACCOUNT";
})(EnvironmentNavigation = exports.EnvironmentNavigation || (exports.EnvironmentNavigation = {}));
const RenderIcon = ({ isActive, environment }) => {
    switch (environment) {
        case EnvironmentNavigation.AGP:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavAgpIcon, { isActive: isActive });
        case EnvironmentNavigation.PKC:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavPkcIcon, { isActive: isActive });
        case EnvironmentNavigation.INVOICES:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavInvoicesIcon, { isActive: isActive });
        case EnvironmentNavigation.OBJECTS:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavObjectsIcon, { isActive: isActive });
        case EnvironmentNavigation.MAIL_SERVER_SETTINGS:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavMailServerSettingsIcon, { isActive: isActive });
        case EnvironmentNavigation.LANGUAGE_CHANGE:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavLanguageChangeIcon, { isActive: isActive });
        case EnvironmentNavigation.MUTATIONS:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavMutationsIcon, { isActive: isActive });
        case EnvironmentNavigation.CONNECTIONS:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavConnectionsIcon, { isActive: isActive });
        case EnvironmentNavigation.COMPANYS:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavCompanysIcon, { isActive: isActive });
        case EnvironmentNavigation.WEBSERVICES:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavWebservicesIcon, { isActive: isActive });
        case EnvironmentNavigation.USERS:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavUsersIcon, { isActive: isActive });
        case EnvironmentNavigation.HELP:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavHelpIcon, { isActive: isActive });
        case EnvironmentNavigation.FILE_TRANSFER:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavFileTransferIcon, { isActive: isActive });
        case EnvironmentNavigation.COCKPIT:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavCockpitIcon, { isActive: isActive });
        case EnvironmentNavigation.ACCOUNT:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavAccountIcon, { isActive: isActive });
        default:
            return (0, jsx_runtime_1.jsx)(NavIcons.NavAgpIcon, { isActive: isActive });
    }
};
exports.RenderIcon = RenderIcon;
//# sourceMappingURL=utils.js.map